module.exports = __webpack_public_path__ + "img/user-my-icon.c17ac2f6.png";